// import { lazy } from "react";

// import Login from "../Pages/auth/Login";
// import VerifyCode from "../Pages/auth/VerifyCode";

// import {
//   Dashboard,
//   MarketWatch,
//   Trades,
//   Orders,
//   Position,
//   ScriptWisePositionHistory,
//   UserWisePositionHistory,
//   AnalyseDevices,
//   TwoFactorAuth,
//   ChangePassword,
//   User,
//   LoginHistory,
//   TradeReport,
//   TradeAnalytics,
//   ScriptWisePLSummary,
// } from "../Pages";

// export const authRouter = [
//   {
//     path: "/dashboard",
//     component: Dashboard,
//     exact: true,
//   },
//   {
//     path: "/marketWatch",
//     component: MarketWatch,
//     exact: true,
//   },
//   {
//     path: "/trades",
//     component: Trades,
//     exact: true,
//   },
//   {
//     path: "/orders",
//     component: Orders,
//     exact: true,
//   },
//   {
//     path: "/position",
//     component: Position,
//     exact: true,
//   },
//   {
//     path: "/scriptWisePositionHistory",
//     component: ScriptWisePositionHistory,
//     exact: true,
//   },
//   {
//     path: "/userWisePositionHistory",
//     component: UserWisePositionHistory,
//     exact: true,
//   },
//   {
//     path: "/analyseDevices",
//     component: AnalyseDevices,
//     exact: true,
//   },
//   {
//     path: "/twofactorauth",
//     component: TwoFactorAuth,
//     exact: true,
//   },
//   {
//     path: "/changepassword",
//     component: ChangePassword,
//     exact: true,
//   },
//   {
//     path: "/user",
//     component: User,
//     exact: true,
//   },
//   {
//     path: "/loginHistory",
//     component: LoginHistory,
//     exact: true,
//   },
//   {
//     path: "/tradeReport",
//     component: TradeReport,
//     exact: true,
//   },
//   {
//     path: "/tradeAnalytics",
//     component: TradeAnalytics,
//     exact: true,
//   },
//   {
//     path: "/scriptWisePlSummary",
//     component: ScriptWisePLSummary,
//     exact: true,
//   },
// ];

// export const publicRouter = [
//   {
//     path: "/login",
//     component: Login,
//   },
//   {
//     path: "/VerifyCode",
//     component: VerifyCode,
//   },
// ];

import { lazy } from "react";

// Lazy load auth pages
const Dashboard = lazy(() => import("../Pages/Dashboard"));
const MarketWatch = lazy(() => import("../Pages/MarketWatch"));
const Trades = lazy(() => import("../Pages/Trades"));
const Orders = lazy(() => import("../Pages/Orders"));
const Position = lazy(() => import("../Pages/Position"));
const ScriptWisePositionHistory = lazy(
  () => import("../Pages/ScriptWisePositionHistory"),
);
const UserWisePositionHistory = lazy(
  () => import("../Pages/UserWisePositionHistory"),
);
const AnalyseDevices = lazy(() => import("../Pages/AnalyseDevices"));
const TwoFactorAuth = lazy(() => import("../Pages/TwoFactorAuth"));
const ChangePassword = lazy(() => import("../Pages/ChangePassword"));
const User = lazy(() => import("../Pages/User"));
const LoginHistory = lazy(() => import("../Pages/LoginHistory"));
const TradeReport = lazy(() => import("../Pages/TradeReport"));
const TradeAnalytics = lazy(() => import("../Pages/TradeAnalytics"));
const ScriptWisePLSummary = lazy(() => import("../Pages/ScriptWisePLSummary"));
const AiTrades = lazy(() => import("../Pages/AiTrades"));
// Non-lazy public routes
import Login from "../Pages/auth/Login";
import VerifyCode from "../Pages/auth/VerifyCode";

export const authRouter = [
  { path: "/dashboard", component: Dashboard, exact: true },
  { path: "/marketWatch", component: MarketWatch, exact: true },
  { path: "/trades", component: Trades, exact: true },
  { path: "/ai-trades", component: AiTrades, exact: true },
  { path: "/orders", component: Orders, exact: true },
  { path: "/position", component: Position, exact: true },
  {
    path: "/scriptWisePositionHistory",
    component: ScriptWisePositionHistory,
    exact: true,
  },
  {
    path: "/userWisePositionHistory",
    component: UserWisePositionHistory,
    exact: true,
  },
  { path: "/analyseDevices", component: AnalyseDevices, exact: true },
  { path: "/twofactorauth", component: TwoFactorAuth, exact: true },
  { path: "/changepassword", component: ChangePassword, exact: true },
  { path: "/user", component: User, exact: true },
  { path: "/loginHistory", component: LoginHistory, exact: true },
  { path: "/tradeReport", component: TradeReport, exact: true },
  { path: "/tradeAnalytics", component: TradeAnalytics, exact: true },
  { path: "/scriptWisePlSummary", component: ScriptWisePLSummary, exact: true },
];

export const publicRouter = [
  { path: "/login", component: Login },
  { path: "/VerifyCode", component: VerifyCode },
];
